/*
 * @Date: 2023-10-27 11:20:13
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-11-10 10:46:24
 * @FilePath: /Client/src/views/signup/const.ts
 * @Description:
 */
import { countries } from '@/common/const'
const countryOptions: {
  key: string;
  desc: string;
  nationalFlagUrl: string;
}[] = countries.map((item) => {
  return {
    ...item,
    nationalFlagUrl: `https://static-s.theckb.com/BusinessMarket/Client/${item.key}.png`
  }
})

// 判断是否h5的宽度
const h5Width = 700

export {
  h5Width,
  countryOptions,
  countries
}
